import {Component, OnInit} from '@angular/core';
import {DataManagementService} from '../services/data-management.service';
import {Constants} from '../constants';
import {Subject} from 'rxjs';
import {AppSettings} from '../../app-settings';

@Component({
    selector: 'app-past-students',
    templateUrl: './past-students.component.html',
    styleUrls: ['./past-students.component.css']
})
export class PastStudentsComponent implements OnInit {
    nominations = [];
    downloadNominations = AppSettings.DOWNLOAD_NOMINATIONS;
    errorMessage;
    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    selectUndefinedOptionValue = undefined;
    programmeId = '0';
    termId = '0';
    pocId;
	academicYear;
	academicYearId = '0';
    programmes;
    terms;

    constructor(private dmService: DataManagementService) {
    }

    getNominations(): void {
        this.dmService.javaGetDataCallByParameter(Constants.NOMINATIONS, this.pocId + '/' + this.termId + '/'
			+ this.programmeId + '/' + this.academicYearId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.nominations = response.data.nominations;
                        this.programmes = response.data.programmes;
                        this.terms = response.data.incoming_terms;
                        // this.academicYear = response.data.academic_year;
                        if (this.nominations.length <= 0) {
                            this.errorMessage = 'There is no data available for past students';
                        } else {
                            this.dtTrigger.next();
                        }
						if (this.terms.length > 0 && this.termId === '0') {
                            this.termId = this.terms[0].incoming_term_id;
                        }
                        /*if (this.academicYear.length > 0 && this.academicYearId === '0') {
                            this.academicYearId = this.academicYear[0].academic_year_id;
                        }*/
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message') && response.message !== null) {
                            this.errorMessage = response.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    ngOnInit() {
        this.pocId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.poc_id;
        this.getNominations();
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
    }

}
